module.exports = __webpack_public_path__ + "img/info-prod-reprovado.68e37f02.svg";